import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ImageCropperComponent } from 'ngx-image-cropper';

import { ProfileEditComponent } from './components/profile-edit/profile-edit.component';
import { SecurityComponent } from './components/security/security.component';
import { SharedModule } from '../shared';
import { ImageCropComponent } from './components';

// Add shared components to this list
export const sharedComponents = [
  ProfileEditComponent,
  SecurityComponent,
  ImageCropComponent
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ImageCropperComponent
  ],
  exports: [
    // components
    ...sharedComponents
  ],
  declarations: [
    // components
    ...sharedComponents
  ],
  providers: [
  ]
})
export class SharedAccountModule {
  constructor() {
  }
}
